import React from 'react'
import * as constant from '../contants'
import Fade from '../../Utils/Fade'
import {isEmpty} from 'lodash'

export default class Deny extends React.PureComponent {
    render() {
        const {question, clickHander, deniedLevel, eligibleData, translationData} = this.props
        let denyContent

        switch (question) {
            default:
            case constant.DIALYSIS:
                denyContent = eligibleData[question].denied
                break
            case constant.RESIDENCY:
                denyContent = eligibleData[question].denied
                break
            case constant.INCOMELEVEL:
                denyContent = eligibleData[question].denied
                break
            case constant.COVERAGE:
                denyContent = eligibleData[question].denied
                break
            case constant.INSURANCE:
                switch (deniedLevel) {
                    default:
                    case 0:
                        denyContent = eligibleData[question].denied
                        break
                    case 1:
                        denyContent = eligibleData[question].deniedROProducts
                        break
                    case 2:
                        denyContent = eligibleData[question].deniedCER
                        break
                    case 3:
                        denyContent = eligibleData[question].deniedPrior
                        break
                }
                break
        }
        return (
            <div className="col-md-8 col-md-offset-2">
                {
                    !isEmpty(denyContent) ?
                        <Fade duration={0.5}>
                            <h1 className="denied-title">{denyContent.title}</h1>
                            <p className="denied-reason" dangerouslySetInnerHTML={{__html: denyContent.reason}}/>
                            <button
                                className="btn btn-default process-prev"
                                onClick={clickHander}>
                                {translationData.back}
                            </button>
                            <p className="denied-info">{denyContent.info}</p>
                        </Fade>
                        :
                        null
                }
            </div>
        )
    }
}